import React, { useState, useEffect, useRef } from 'react';
import Badge from './Badge';

interface ProgressBarProps {
  initialTimestamp: number;
  expirationTimestamp: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ initialTimestamp, expirationTimestamp }) => {

  const [progress, setProgress] = useState(0);
  const totalDurationRef = useRef(expirationTimestamp - initialTimestamp);

  useEffect(() => {

    const totalDuration = expirationTimestamp - initialTimestamp;
    totalDurationRef.current = totalDuration;

    if (totalDuration <= 0) {
      setProgress(100);
      return;
    }

    const update = () => {
      const remaining = Math.max(0, expirationTimestamp - Date.now());
      const progressValue = Math.min(
        100,
        Math.max(
          0,
          Math.round((1 - remaining / totalDurationRef.current) * 100)
        )
      );

      setProgress(progressValue);
    };

    update();

    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);

  }, [initialTimestamp, expirationTimestamp]);

  return (
    <div className="relative flex items-center justify-between rounded-full bg-gray-100 shadow-inner h-1.5 w-full">
      <div
        style={{ width: `${progress}%` }}
        className={`h-full rounded-full transition-all duration-500 ease-linear ${
          progress > 60 ? 'bg-shopfood-error' : 'bg-shopfood-info'
        }`}
      />
      <Badge className="absolute h-4 right-1.5 opacity-90 rounded-full">
        {progress}%
      </Badge>
    </div>
  );
};

export default ProgressBar;